import React from 'react';
import { ActivityCard } from './ActivityCard';

interface ActivitySectionProps {
  activities: any;
  loading?: boolean;
}

export function ActivitySection({
  activities,
  loading = false,
}: ActivitySectionProps) {
  const [showContent, setShowContent] = React.useState(false);

  React.useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setShowContent(true), 50);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (!activities && loading) {
    return (
      <div className="activity-section">
        <div
          style={{
            padding: '12px',
            textAlign: 'center',
            color: '#a1a1aa',
            fontSize: '0.9rem',
          }}
        >
          Loading activity...
        </div>
      </div>
    );
  }

  const safeActivities = activities || { ratings: [], watchlist: [] };

  // Filter activities: "Recently Rated" where rating exists (max 10)
  const recentlyRated = safeActivities.ratings?.slice(0, 10) || [];

  // Filter activities: "Recently Added to Watchlist" where watchlist_date exists (max 10)
  const recentlyWatchlisted = safeActivities.watchlist?.slice(0, 10) || [];

  return (
    <div className="activity-section">
      {/* Recently Rated Section */}
      {recentlyRated.length > 0 && (
        <div className="activity-section__column">
          <div className="listing-info">
            <span className="listing-info__title">Recently Rated</span>
          </div>
          <div
            className={`activity-scroll ${showContent ? 'fade-in' : ''}`}
            style={{ opacity: showContent ? 1 : 0 }}
          >
            <div className="activity-scroll__list">
              {recentlyRated.map((movie, i) => (
                <ActivityCard
                  key={`rating-${movie.id}-${i}`}
                  movie={movie}
                  activity={movie.activity}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Recently Added to Watchlist Section */}
      {recentlyWatchlisted.length > 0 && (
        <div className="activity-section__column">
          <div className="listing-info">
            <span className="listing-info__title">Recently Watchlisted</span>
          </div>
          <div
            className={`activity-scroll ${showContent ? 'fade-in' : ''}`}
            style={{ opacity: showContent ? 1 : 0 }}
          >
            <div className="activity-scroll__list">
              {recentlyWatchlisted.map((movie, i) => (
                <ActivityCard
                  key={`watchlist-${movie.id}-${i}`}
                  movie={movie}
                  activity={movie.activity}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Empty state */}
      {recentlyRated.length === 0 && recentlyWatchlisted.length === 0 && (
        <div
          style={{
            padding: '12px',
            textAlign: 'center',
            color: '#a1a1aa',
            fontSize: '0.9rem',
          }}
        >
          No recent activity
        </div>
      )}
    </div>
  );
}
